(() => {
  const selector = '[data-kz-cookie-preferences]';
  const bannerScriptUrl = 'https://cdn.shopify.com/shopifycloud/privacy-banner/storefront-banner.js';
  let bannerLoader;

  const hasPreferencesModal = () =>
    Boolean(window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function');

  const loadPreferencesModal = () => {
    if (hasPreferencesModal()) return Promise.resolve();
    if (bannerLoader) return bannerLoader;

    bannerLoader = new Promise((resolve, reject) => {
      let script = document.querySelector(`script[src="${bannerScriptUrl}"]`);

      const handleLoad = () => {
        if (hasPreferencesModal()) resolve();
        else reject(new Error('Shopify privacy preferences are unavailable.'));
      };

      if (script) {
        script.addEventListener('load', handleLoad, { once: true });
        script.addEventListener('error', reject, { once: true });
        window.setTimeout(handleLoad, 0);
        return;
      }

      script = document.createElement('script');
      script.src = bannerScriptUrl;
      script.async = true;
      script.addEventListener('load', handleLoad, { once: true });
      script.addEventListener('error', reject, { once: true });
      document.head.appendChild(script);
    }).catch((error) => {
      bannerLoader = undefined;
      throw error;
    });

    return bannerLoader;
  };

  const openPreferences = async (button) => {
    button.setAttribute('aria-busy', 'true');

    try {
      await loadPreferencesModal();
      await window.privacyBanner.showPreferences();
    } catch (_error) {
      const fallbackUrl = button.dataset.kzPrivacyUrl;
      if (fallbackUrl) window.location.assign(fallbackUrl);
    } finally {
      button.removeAttribute('aria-busy');
    }
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest(selector);
    if (!button) return;

    event.preventDefault();
    openPreferences(button);
  });
})();
